import React from "react";
import * as Mui from "@mui/material";
import classNames from "classnames";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface OwnProps {
	expanded: boolean;
	onToggle: () => void;
	/** Header row content (chevron / name / count / kebab). */
	summary: React.ReactNode;
	/** Expanded body content. */
	children: React.ReactNode;
	/** Remove AccordionDetails padding so content (e.g. a table) can span the full card width. */
	disableDetailsPadding?: boolean;
	/** Extra class on the accordion card, e.g. to change the gap between cards. */
	className?: string;
	/** Extra class on the summary row, e.g. for a taller header than MUI's default. */
	summaryClassName?: string;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/**
 * MAX-3878 — card-style accordion matching the Figma campaign-category design (rounded 8px corners,
 * 1px border-card outline, gap-separated, no default MUI divider/elevation).
 *
 * Promoted from the campaigns page to shared for the IDX Pages categories (MAX-4419 FD-VPLAT-26).
 */
const Component: React.FC<Props> = ({
	expanded,
	onToggle,
	summary,
	children,
	disableDetailsPadding,
	className,
	summaryClassName,
	classes = {},
}) => (
	<Mui.Accordion
		className={classNames(classes.accordion, className)}
		elevation={0}
		expanded={expanded}
		onChange={onToggle}
	>
		<Mui.AccordionSummary className={summaryClassName}>{summary}</Mui.AccordionSummary>
		<Mui.AccordionDetails className={disableDetailsPadding ? classes.detailsNoPadding : undefined}>
			{children}
		</Mui.AccordionDetails>
	</Mui.Accordion>
);

export const CategoryAccordion = withStyles(Component, styles);
